import { motion, useTransform } from "framer-motion";
import { useLaunchGeometry } from "./useLaunchGeometry";
import { useLaunchFlight } from "./useLaunchFlight";

export const LaunchRocket = ({ rootRef, motionState, progress, known, isUnlocked }) => {
  const geometry = useLaunchGeometry(rootRef);
  const coordinates = useLaunchFlight({ geometry, isUnlocked, ...motionState });
  const bridge = useTransform(geometry, (g) => g
    ? `M${g.start + g.length} ${g.y} Q${(g.start + g.length + g.moonX) / 2} ${g.y} ${g.moonX} ${g.moonY} Q${(g.moonX + g.beyondX) / 2} ${g.moonY - 8} ${g.beyondX} ${g.beyondY}` : "M0 0");
  const power = useTransform(motionState.displayed, (p) => 0.2 + p * 0.8);
  const engineOpacity = useTransform(motionState.displayed, (p) => 0.35 + p * 0.6);
  const mode = !known ? "waiting" : motionState.celebrating ? "departure" : isUnlocked && !motionState.reduced ? "beyond" : "tracking";
  return (
    <div className="launch-flight-layer" aria-hidden="true" data-testid="launch-flight-layer">
      <svg className="launch-bridge"><motion.path d={bridge} /></svg>
      <motion.div className="launch-rocket" style={coordinates} data-testid="launch-rocket"
        data-progress={known ? progress : "unknown"} data-flight={mode} data-power={known && progress > 0 ? "active" : "idle"}>
        <motion.div className="launch-engine" style={{ scaleX: power, opacity: engineOpacity }} data-testid="launch-rocket-engine">
          <span className="launch-engine__plasma" /><span className="launch-engine__hot-core" />
          {[0, 1, 2].map((i) => <i className="launch-engine__particle" key={i} style={{ "--particle": i }} />)}
        </motion.div>
        <img src="/assets/artwork/launch/kingbullish-rocket.webp" alt="" width="285" height="117" decoding="async" draggable="false" />
      </motion.div>
    </div>
  );
};